var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.errorList.length > 0)?_c('div',[_c('h2',[_vm._v("There was an error fetching data.")]),_vm._v(" "),_c('ul',{staticClass:"errors"},_vm._l((_vm.errorList),function(error){return _c('li',[_vm._v(_vm._s(error))])}))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67c348cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorList.vue
// module id = Cxra
// module chunks = 1